import {HomeI18n} from '@/locales/base.message.locales';
import {about} from '@/locales/pt-br/about.locale';
import {howItWorks} from '@/locales/pt-br/how-it-works.locale';
import {ideasPlace} from '@/locales/pt-br/ideas-place.locale';
import {partners} from '@/locales/pt-br/partners.locale';

export const home: HomeI18n = {
  title: 'Como os problemas sociais complexos são grandes demais para serem resolvidos sozinhos',
  subtitle: 'Nós criamos uma liga',
  header: {
    text: 'NÓS CRIAMOS UMA LIGA POR QUE PROBLEMAS SOCIAIS COMPLEXOS SÃO GRANDES DEMAIS PARA RESOLVER SOZINHO',
    sub_text: 'Porque problemas sociais complexos são grandes demais para serem resolvidos sozinhos',
    title: 'A IKONE destrava o poder das sinergias conectando problemas e soluções através de inovação aberta da sua plataforma de desafios',
    video: 'Assista ao vídeo',
  },
  about,
  how_it_works: howItWorks,
  ideas_place: ideasPlace,
  impact_board: {
    title: 'Conselho de impacto social',
    button: 'CONHEÇA A LIGA',
    loading_members: 'Carregando membros do conselho...',
  },
  lives_impacted: 'Vidas impactadas <br/> pelos nossos desafios <br/> e soluções ao redor <br/> do mundo',
  partners,
};
